import Done from '@mui/icons-material/Done';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Grid, Typography } from '@mui/material';
import { WsColors } from 'wisestep-base';

interface MappingNotificationProps {
  variant: 'NEW' | 'EXIST' | 'DUPLICATE';
}
const MappingNotification = ({ variant }: MappingNotificationProps) => {
  const text1 = 'Candidate already added';
  const text2 = 'Looks like a new candidate';
  const text3 = 'Candidate already added to job';
  const desc1 =
    'Candidate with email is previously mapped to a job. Update details and click “Save” to proceed.';
  const desc2 = 'Candidate with the email does not exist. Upload CV to parse data automatically.';
  const desc3 =
    'This Candidate is already mapped for the job. Please change the job to map candidate.';
  const getCoolr = (variant, bg) => {
    if (variant === 'NEW') return bg && WsColors.TertiaryShades100;
    if (variant === 'EXIST') return bg ? WsColors.Green100 : '#00918B';
    if (variant === 'DUPLICATE') return bg ? WsColors.Red100 : '#C00000';
  };
  return (
    <Box borderRadius={2} bgcolor={getCoolr(variant, true)} p={2} m={2} rowGap={1}>
      <Grid item container gap={1} pb={1}>
        {variant === 'EXIST' ? (
          <Done sx={{ color: WsColors.Green500, fontSize: 24 }} />
        ) : variant === 'NEW' ? (
          <InfoOutlined sx={{ fontSize: 24 }} />
        ) : (
          <InfoOutlined sx={{ color: WsColors.Red }} />
        )}
        <Typography fontSize="16px" fontWeight={700} color={getCoolr(variant, false)}>
          {variant === 'EXIST' ? text1 : variant === 'NEW' ? text2 : text3}
        </Typography>
      </Grid>
      <Typography fontSize="14px" fontWeight={400} color={getCoolr(variant, false)}>
        {variant === 'EXIST' ? desc1 : variant === 'NEW' ? desc2 : desc3}
      </Typography>
    </Box>
  );
};

export default MappingNotification;
